import React from "react";

import { Stack } from "@mui/material";

import Switch from "../../../../components/Redux/Switch";
import { ReduxTextField } from "../../../../components/Redux/TextField";
import {
  getRouteFormProperty,
  setRouteFormError,
  setRouteFormProperty,
} from "../../../../slices/routes";
import InnerSetting from "./InnerSetting";

type RedirectBuilderProps = {
  readonly: boolean;
};
export const RedirectBuilder = ({ readonly }: RedirectBuilderProps) => {
  return (
    <Stack spacing={1}>
      <InnerSetting docsKey="https-redirect" label={"Https Redirect"}>
        <Switch
          label=""
          disabled={readonly}
          color="primary"
          path="redirect.httpsRedirect"
          setter={setRouteFormProperty}
          getter={getRouteFormProperty}
          errorHandler={setRouteFormError}
        />{" "}
      </InnerSetting>

      <InnerSetting docsKey="scheme-redirect" label={"Scheme Redirect"}>
        <ReduxTextField
          fullWidth
          path="redirect.schemeRedirect"
          setter={setRouteFormProperty}
          getter={getRouteFormProperty}
          errorHandler={setRouteFormError}
        />
      </InnerSetting>

      <InnerSetting docsKey="host-redirect" label={"Host Redirect"}>
        <ReduxTextField
          fullWidth
          path="redirect.hostRedirect"
          setter={setRouteFormProperty}
          getter={getRouteFormProperty}
          errorHandler={setRouteFormError}
        />
      </InnerSetting>

      <InnerSetting docsKey="port-redirect" label={"Port Redirect"}>
        <ReduxTextField
          fullWidth
          path="redirect.portRedirect"
          setter={setRouteFormProperty}
          getter={getRouteFormProperty}
          errorHandler={setRouteFormError}
        />
      </InnerSetting>

      <InnerSetting docsKey="path-redirect" label={"Path Redirect"}>
        <ReduxTextField
          fullWidth
          path="redirect.pathRedirect"
          setter={setRouteFormProperty}
          getter={getRouteFormProperty}
          errorHandler={setRouteFormError}
        />
      </InnerSetting>

      <InnerSetting docsKey="prefix-rewrite-redirect" label={"Prefix Rewrite"}>
        <ReduxTextField
          fullWidth
          path="redirect.prefixRewrite"
          setter={setRouteFormProperty}
          getter={getRouteFormProperty}
          errorHandler={setRouteFormError}
        />
      </InnerSetting>

      <InnerSetting docsKey="response-code" label={"Response Code"}>
        <ReduxTextField
          fullWidth
          path="redirect.responseCode"
          setter={setRouteFormProperty}
          getter={getRouteFormProperty}
          errorHandler={setRouteFormError}
        />
      </InnerSetting>

      <InnerSetting docsKey="strip-query" label={"Strip Query"}>
        <Switch
          disabled={readonly}
          color="primary"
          path="redirect.stripQuery"
          setter={setRouteFormProperty}
          getter={getRouteFormProperty}
          errorHandler={setRouteFormError}
          label=""
        />
      </InnerSetting>
    </Stack>
  );
};
